module.exports = __webpack_public_path__ + "static/media/snakewoman.ac39cb7d.jpg";